var _rect, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSearchBg = function SvgSearchBg(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.921387,
    y: 0.179688,
    width: 34.6316,
    height: 34.6316,
    rx: 17.3158,
    fill: "url(#paint0_linear_1_6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.658 24.9256L22.4457 21.7076L25.658 24.9256ZM24.2259 17.4069C24.2259 19.0211 23.5846 20.5693 22.4432 21.7107C21.3017 22.8522 19.7536 23.4934 18.1393 23.4934C16.525 23.4934 14.9769 22.8522 13.8354 21.7107C12.694 20.5693 12.0527 19.0211 12.0527 17.4069C12.0527 15.7926 12.694 14.2445 13.8354 13.103C14.9769 11.9616 16.525 11.3203 18.1393 11.3203C19.7536 11.3203 21.3017 11.9616 22.4432 13.103C23.5846 14.2445 24.2259 15.7926 24.2259 17.4069V17.4069Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6",
    x1: 15.5316,
    y1: -83.6064,
    x2: 78.3099,
    y2: -3.34712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA57FF"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-bg.3b9aaa33.svg";
export { ForwardRef as ReactComponent };